// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.highcharts-figure,
.highcharts-data-table table {
  min-width: 310px;
  max-width: 800px;
  margin: 1em auto;
}

#container {
  height: 400px;
}

.highcharts-data-table table {
  font-family: Verdana, sans-serif;
  border-collapse: collapse;
  border: 1px solid #ebebeb;
  margin: 10px auto;
  text-align: center;
  width: 100%;
  max-width: 500px;
}

.highcharts-data-table caption {
  padding: 1em 0;
  font-size: 1.2em;
  color: #555;
}

.highcharts-data-table th {
  font-weight: 600;
  padding: 0.5em;
}

.highcharts-data-table td,
.highcharts-data-table th,
.highcharts-data-table caption {
  padding: 0.5em;
}

.highcharts-data-table thead tr,
.highcharts-data-table tr:nth-child(even) {
  background: #f8f8f8;
}

.highcharts-data-table tr:hover {
  background: #f1f7ff;
}

.highcharts-title {
  font-size: 16px !important;
}

.highcharts-legend {
  font-size: 15px !important;
  font-weight: 600 !important;
}
.highcharts-legend .highcharts-legend-box {
  width: 68% !important;
}

.highcharts-yaxis {
  font-size: 16px !important;
}

.highcharts-xaxis-labels {
  font-size: 15px !important;
}

.highcharts-data-label {
  font-size: 17px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/metricshighchart/metricshighchart.component.scss"],"names":[],"mappings":"AAiDA;;EAEI,gBAAA;EACA,gBAAA;EACA,gBAAA;AAhDJ;;AAmDA;EACI,aAAA;AAhDJ;;AAmDA;EACI,gCAAA;EACA,yBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AAhDJ;;AAmDA;EACI,cAAA;EACA,gBAAA;EACA,WAAA;AAhDJ;;AAmDA;EACI,gBAAA;EACA,cAAA;AAhDJ;;AAmDA;;;EAGI,cAAA;AAhDJ;;AAmDA;;EAEI,mBAAA;AAhDJ;;AAmDA;EACI,mBAAA;AAhDJ;;AAkDA;EACI,0BAAA;AA/CJ;;AAiDA;EACI,0BAAA;EACA,2BAAA;AA9CJ;AA+CI;EACI,qBAAA;AA7CR;;AAgDA;EACI,0BAAA;AA7CJ;;AA+CA;EACI,0BAAA;AA5CJ;;AA8CA;EACI,0BAAA;AA3CJ","sourcesContent":["// #container {\r\n//     height: 600px;\r\n// }\r\n\r\n// .highcharts-figure,\r\n// .highcharts-data-table table {\r\n//     min-width: 310px;\r\n//     max-width: 800px;\r\n//     margin: 1em auto;\r\n// }\r\n\r\n// .highcharts-data-table table {\r\n//     font-family: Verdana, sans-serif;\r\n//     border-collapse: collapse;\r\n//     border: 1px solid #ebebeb;\r\n//     margin: 10px auto;\r\n//     text-align: center;\r\n//     width: 100%;\r\n//     max-width: 500px;\r\n// }\r\n\r\n// .highcharts-data-table caption {\r\n//     padding: 1em 0;\r\n//     font-size: 1.2em;\r\n//     color: #555;\r\n// }\r\n\r\n// .highcharts-data-table th {\r\n//     font-weight: 600;\r\n//     padding: 0.5em;\r\n// }\r\n\r\n// .highcharts-data-table td,\r\n// .highcharts-data-table th,\r\n// .highcharts-data-table caption {\r\n//     padding: 0.5em;\r\n// }\r\n\r\n// .highcharts-data-table thead tr,\r\n// .highcharts-data-table tr:nth-child(even) {\r\n//     background: #f8f8f8;\r\n// }\r\n\r\n// .highcharts-data-table tr:hover {\r\n//     background: #f1f7ff;\r\n// }\r\n\r\n\r\n\r\n.highcharts-figure,\r\n.highcharts-data-table table {\r\n    min-width: 310px;\r\n    max-width: 800px;\r\n    margin: 1em auto;\r\n}\r\n\r\n#container {\r\n    height: 400px;\r\n}\r\n\r\n.highcharts-data-table table {\r\n    font-family: Verdana, sans-serif;\r\n    border-collapse: collapse;\r\n    border: 1px solid #ebebeb;\r\n    margin: 10px auto;\r\n    text-align: center;\r\n    width: 100%;\r\n    max-width: 500px;\r\n}\r\n\r\n.highcharts-data-table caption {\r\n    padding: 1em 0;\r\n    font-size: 1.2em;\r\n    color: #555;\r\n}\r\n\r\n.highcharts-data-table th {\r\n    font-weight: 600;\r\n    padding: 0.5em;\r\n}\r\n\r\n.highcharts-data-table td,\r\n.highcharts-data-table th,\r\n.highcharts-data-table caption {\r\n    padding: 0.5em;\r\n}\r\n\r\n.highcharts-data-table thead tr,\r\n.highcharts-data-table tr:nth-child(even) {\r\n    background: #f8f8f8;\r\n}\r\n\r\n.highcharts-data-table tr:hover {\r\n    background: #f1f7ff;\r\n}\r\n.highcharts-title{\r\n    font-size: 16px !important;\r\n}\r\n.highcharts-legend{\r\n    font-size: 15px !important;\r\n    font-weight: 600 !important;\r\n    .highcharts-legend-box{\r\n        width: 68% !important;\r\n    }\r\n}\r\n.highcharts-yaxis{\r\n    font-size: 16px !important;\r\n}\r\n.highcharts-xaxis-labels{\r\n    font-size: 15px !important;\r\n}\r\n.highcharts-data-label{\r\n    font-size: 17px !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
